module.exports = __webpack_public_path__ + "static/media/jaels-creations-mobile-1.67d9d126.png";